import { S3_FOLDERS_LEGACY, S3_HOST_URL } from '@/constants/legacy/constEnv'

export const MembershipImageUrl = {
  OgImageUrl: `${S3_HOST_URL}/${S3_FOLDERS_LEGACY.ASSET_IMAGES}/membership/membership_og.png`,
  KakaoShareImageUrl: `${S3_HOST_URL}/${S3_FOLDERS_LEGACY.ASSET_IMAGES}/membership/membership_kakao_share.png`,
}
